import Axios from "axios";
import { message } from "antd";

export default function postCompany(data, cb) {
  return (dispatch) => {
    dispatch({
      type: "Loading",
      payload: true,
    });
    Axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/add-company`,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: data,
    })
      .then((response) => {
        dispatch({
          type: "Loading",
          payload: false,
        });
        if (cb) {
          cb(response);
        }
      })
      .catch((err) => {
        dispatch({
          type: "Loading",
          payload: false,
        });
        message.error(err?.response?.data?.message || "Something went wrong");
      });
  };
}
